import {
  Alert,
  Content,
  Heading,
  Section,
} from "@mittwald/flow-remote-react-components";
import { Suspense } from "react";
import { AppInstallationPHPSettings } from "../components/AppInstallationPHPSettings.tsx";
import { AppInstallationPHPSettingsSkeleton } from "../components/AppInstallationPHPSettingsSkeleton.tsx";
import { OPcacheStats } from "../components/OPcacheStats.tsx";
import { StatsSkeleton } from "../components/StatsSkeleton.tsx";
import { APCuStats } from "../components/APCuStats.tsx";
import { useConfig } from "@mittwald/ext-bridge/react";
import { useProject } from "../hooks/useProject.ts";
import semver from "semver/preload";

export const Editor = () => {
  const config = useConfig();

  const appInstallationId = config.appInstallationId;
  if (!appInstallationId) {
    throw new Error("appInstallationId is not defined");
  }

  const projectId = config.projectId;
  if (!projectId) {
    throw new Error("projectId is not defined");
  }

  const project = useProject(projectId);

  const appInstallation = project.data.appInstallations.find(
    (a) => a.id == appInstallationId,
  );

  if (!appInstallation) {
    throw new Error("app installation not found in project");
  }

  if (!appInstallation.phpVersion) {
    return (
      <Section>
        <Heading>PHP-Einstellungen</Heading>
        <Alert status="info">
          <Heading>Kein PHP installiert</Heading>
          <Content>
            In deiner App ist keine PHP-Version installiert. Wenn du PHP in
            dieser App benötigst, kannst du es über den Tab &quot;Software&quot;
            installieren.
          </Content>
        </Alert>
      </Section>
    );
  }

  const showCache = semver.gte(appInstallation.phpVersion, "7.2.0");

  return (
    <>
      <Suspense
        fallback={
          <Section>
            <AppInstallationPHPSettingsSkeleton />
          </Section>
        }
      >
        <AppInstallationPHPSettings
          projectId={projectId}
          appInstallationId={appInstallationId}
        />
      </Suspense>
      {showCache && (
        <Section>
          <Heading>Cache-Auslastung deiner App</Heading>
          <Suspense fallback={<StatsSkeleton />}>
            <OPcacheStats
              projectId={projectId}
              appInstallationId={appInstallationId}
            />
          </Suspense>
          <Suspense fallback={<StatsSkeleton />}>
            <APCuStats
              projectId={projectId}
              appInstallationId={appInstallationId}
            />
          </Suspense>
        </Section>
      )}
    </>
  );
};
